import AskAccountType from "../../components/pages/loggedIn/onboarding/AskAccountType";
import AskAddress from "../../components/pages/loggedIn/onboarding/AskAddress";
import AskBio from "../../components/pages/loggedIn/onboarding/AskBio";
import AskContactInfo from "../../components/pages/loggedIn/onboarding/AskContactInfo";
import AskDob from "../../components/pages/loggedIn/onboarding/AskDob";
import AskDobPage from "../../components/pages/loggedIn/onboarding/AskDob";
import AskDocumentVerification from "../../components/pages/loggedIn/onboarding/AskDocumentVerification";
import AskEducation from "../../components/pages/loggedIn/onboarding/AskEducation";
import AskGender from "../../components/pages/loggedIn/onboarding/AskGender";
import AskLocation from "../../components/pages/loggedIn/onboarding/AskLocation";
import AskName from "../../components/pages/loggedIn/onboarding/AskName";
import AskNgoSize from "../../components/pages/loggedIn/onboarding/AskNgoSize";
import AskNgoType from "../../components/pages/loggedIn/onboarding/AskNgoType";
import AskPhoneNumber from "../../components/pages/loggedIn/onboarding/AskPhoneNumber";
import AskWorkExperience from "../../components/pages/loggedIn/onboarding/AskWorkExperience";
import VerifyEmail from "../../components/pages/loggedIn/onboarding/VerifyEmail";
import AskLeadership from "../../components/pages/loggedIn/onboarding/AskLeadership";
import AskCompanySize from "../../components/pages/loggedIn/onboarding/AskCompanySize";
import AskProfileImage from "../../components/pages/loggedIn/onboarding/AskProfileImage";
import AskDonationInfo from "../../components/pages/loggedIn/onboarding/AskDonationInfo";

// helper
const skipped = (user, field) => user?.[field] === true;

export function getOnboardingComponent(loggedInUser) {
  if (!loggedInUser) return null;

  // 1. Verify email first
  if (!loggedInUser.emailConfirmed) {
    return <VerifyEmail />;
  }

  // 2. If account type missing → ask that first
  if (!loggedInUser.accountType) {
    return <AskAccountType />;
  }

  if (
    !loggedInUser.profileImage &&
    !skipped(loggedInUser, "profileImageOnboardingSkipped")
  ) {
    return <AskProfileImage />;
  }

  // 3. Individual flow
  if (loggedInUser.accountType === "INDIVIDUAL") {
    if (!loggedInUser.name && !skipped(loggedInUser, "nameOnboardingSkipped")) {
      return <AskName />;
    }

    if (
      !loggedInUser.educationalBackground &&
      !skipped(loggedInUser, "educationOnboardingSkipped")
    )
      return <AskEducation />;
    if (
      !loggedInUser.workExperience &&
      !skipped(loggedInUser, "workExperienceOnboardingSkipped")
    )
      return <AskWorkExperience />;
    if (
      !loggedInUser.phoneNumber &&
      !skipped(loggedInUser, "phoneNumberOnboardingSkipped")
    )
      return <AskPhoneNumber />;
    if (!loggedInUser.bio && !skipped(loggedInUser, "bioOnboardingSkipped"))
      return <AskBio />;

    if (
      !loggedInUser.upiId &&
      !loggedInUser.bankDetails &&
      !skipped(loggedInUser, "donationOnboardingSkipped")
    )
      return <AskDonationInfo />;
    if (
      !loggedInUser.dateOfBirth &&
      !skipped(loggedInUser, "dateOfBirthOnboardingSkipped")
    )
      return <AskDobPage />;
    if (
      !loggedInUser.city &&
      !skipped(loggedInUser, "locationOnboardingSkipped")
    )
      return <AskLocation />;
    if (
      !loggedInUser.gender &&
      !skipped(loggedInUser, "genderOnboardingSkipped")
    )
      return <AskGender />;
  }

  // 4. NGO flow
  if (loggedInUser.accountType === "NGO") {
    if (!loggedInUser.name && !skipped(loggedInUser, "nameOnboardingSkipped"))
      return <AskName />;
    if (
      !loggedInUser.founderName &&
      !loggedInUser.leaderName &&
      !skipped(loggedInUser, "leadershipDetailsOnboardingSkipped")
    )
      return <AskLeadership />;
    if (
      !loggedInUser.memberCount &&
      !loggedInUser.numberOfPeopleHelpedYearly &&
      !loggedInUser.annualBudget &&
      !skipped(loggedInUser, "ngoStatOnboardingSkipped")
    )
      return <AskNgoSize />;
    if (
      !loggedInUser.documentVerification &&
      !skipped(loggedInUser, "documentVerificationOnboardingSkipped")
    )
      return <AskDocumentVerification />;
    if (
      !loggedInUser.phoneNumbers &&
      !skipped(loggedInUser, "phoneNumbersOnboardingSkipped")
    )
      return <AskContactInfo />;

    if (!loggedInUser.bio && !skipped(loggedInUser, "bioOnboardingSkipped"))
      return <AskBio />;
    if (
      !loggedInUser.address &&
      !skipped(loggedInUser, "addressOnboardingSkipped")
    )
      return <AskAddress />;
    if (
      !loggedInUser.ngoType &&
      !skipped(loggedInUser, "ngoTypeOnboardingSkipped")
    )
      return <AskNgoType />;
    if (
      !loggedInUser.dateOfBirth &&
      !skipped(loggedInUser, "dateOfBirthOnboardingSkipped")
    )
      return <AskDob />;
    if (
      !loggedInUser.city &&
      !skipped(loggedInUser, "locationOnboardingSkipped")
    )
      return <AskLocation />;
    if (
      !loggedInUser.upiId &&
      !loggedInUser.bankDetails &&
      !skipped(loggedInUser, "donationOnboardingSkipped")
    )
      return <AskDonationInfo />;
  }

  // 5. Company flow
  if (loggedInUser.accountType === "COMPANY") {
    if (!loggedInUser.name && !skipped(loggedInUser, "nameOnboardingSkipped"))
      return <AskName />;
    if (
      !loggedInUser.founderName &&
      !loggedInUser.leaderName &&
      !skipped(loggedInUser, "leadershipDetailsOnboardingSkipped")
    )
      return <AskLeadership />; // reusing NGO leadership page
    if (
      !loggedInUser.memberCount &&
      !skipped(loggedInUser, "companyStatOnboardingSkipped")
    )
      return <AskCompanySize />;
    if (
      !loggedInUser.phoneNumbers &&
      !skipped(loggedInUser, "phoneNumbersOnboardingSkipped")
    )
      return <AskContactInfo />;
    if (!loggedInUser.bio && !skipped(loggedInUser, "bioOnboardingSkipped"))
      return <AskBio />;
    if (
      !loggedInUser.address &&
      !skipped(loggedInUser, "addressOnboardingSkipped")
    )
      return <AskAddress />;
    if (
      !loggedInUser.ngoType &&
      !skipped(loggedInUser, "ngoTypeOnboardingSkipped")
    )
      return <AskNgoType />;
    if (
      !loggedInUser.dateOfBirth &&
      !skipped(loggedInUser, "dateOfBirthOnboardingSkipped")
    )
      return <AskDob />;
    if (
      !loggedInUser.city &&
      !skipped(loggedInUser, "locationOnboardingSkipped")
    )
      return <AskLocation />;
  }

  return null;
}
